import { loadStripe } from "@stripe/stripe-js";
import "./App.css";
import MainRouter from "./Router/MainRouter";
import { useEffect } from "react";
import { pushTraceLogOnClose } from "./Component/Dashboard/sessionEventPush";

function App() {
  return (
    <div className="App">
      {/* <Elements stripe={stripePromise}> */}
      <MainRouter />
      {/* </Elements> */}
    </div>
  );
}

export default App;
